const autoNgTemplateLoaderTemplate1 = require('./node.html');

angular.module('shbdeployer.kubernetes').component('kubernetesNodeView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesNodeController',
  controllerAs: 'ctrl',
  bindings: {
    endpoint: '<',
    $transition$: '<',
  },
});
